import styled from 'styled-components'
import { Box } from '@pinchenterprisesnpm/friday-ui'

export const SectionItemText = styled(Box)`
  margin-bottom: ${({ theme }) => theme.mp.sm};
  margin-top: ${({ theme }) => theme.mp.sm};
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
`

export const ScreeningSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.mp.sm};
`
